import { axios } from '../util/axios'
import platform from '../util/platform'

const API_LOGIN_EMAIL_SELF_SERVICE = '/2fa/v0/login/selfservice/pincode'

export const sendPinCode = token =>
  axios.post(
    '/v1/user/send/pincode',
    {
      token,
      platform,
    },
    {
      withCredentials: false,
      timeout: 20000,
    }
  )

export const loginWithPinCode = (token, code, sessionTokens) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-email_2fa'
  return axios.post(
    '/v2/user/login/pincode',
    {
      token,
      code,
      platform,
      session_ids: sessionTokens,
    },
    {
      withCredentials: true,
      timeout: 20000,
    }
  )
}

export const loginWithEmailSelfService = (token, code, sessionTokens) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-email_2fa'
  return axios.post(API_LOGIN_EMAIL_SELF_SERVICE, {
    code,
    token,
    platform,
    session_ids: sessionTokens,
  })
}
